export default "__VITE_ASSET__CYEUwtPL__"